<template>
  <!-- 横向轮播 -->
  <div :style="wordStyle" class="marquee-container">
    <div v-if="configurationData.horizontal"  class="app">
      <div :style="styles.fontStyle" ref="msg">
        <p :style="styles.fontStyle" ref="ps">
          <span :style="styles.fontStyle" ref="su">
            {{ configurationData.swiperList }}
            </span>
          <span :style="styles.fontStyle" ref="sv"></span>
        </p>
      </div>
    </div>
    <marquee-up
      :styleObj="styles.fontStyle"
      v-else
      :swiperList="swiperList"
    ></marquee-up>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import MarqueeUp from './MarqueeUp.vue';
export default {
  name: 'CPublicCarouselSwipers',
  components: { MarqueeUp },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'supercore-lottery-',
    };
  },
  computed: {
    wordStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    fontColor() {
      // 字体颜色
      return this.configurationData.fontColor;
    },
    fontSize() { // 字体大小
      return this.configurationData.fontSize;
    },
    horizontal() {
      // 横向和纵向切换
      return this.configurationData.horizontal;
    },
    swiperList: {
      get() {
        return this.configurationData.swiperList;
      },
      set(newValue) {
        return newValue;
      },
    },
    // borderBkColor(){ // 边框颜色
    //   return this.configurationData.borderBkColor
    // }
  },
  async mounted() {
    if (this.configurationData.horizontal === true) {
      this.carouselText();
    }
  },
  methods: {
    async initialize() {},
    carouselText() {
      const { msg } = this.$refs;
      const { ps } = this.$refs;
      const { su } = this.$refs;
      const { sv } = this.$refs;
      su.innerText = this.configurationData.swiperList;
      sv.innerText = this.configurationData.swiperList;
      ps.append(su);
      ps.append(sv);
      msg.innerText = '';
      msg.append(ps);
      this.carouselAnime(0);
    },
    // 轮播动画
    carouselAnime(right) {
      const msgArea = this.$refs.msg.children[0];
      let rsg = right;
      if (rsg < msgArea.offsetWidth - this.$refs.msg.offsetWidth) {
        msgArea.style.transform = `translateX(-${rsg}px)`;
        if (rsg > msgArea.children[0].offsetWidth) {
          rsg =  0;
          msgArea.style.transform = 'translateX(0)';
        }
        rsg = rsg + 1;
      }
      setTimeout(() => {
        // 定时器开启轮播
        this.carouselAnime(rsg);
      }, 16.7);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './styles.scss';

.app {
  width: 100%;
  // height: 40px;
  height: 100%;
  border-radius: 0.2rem;
  padding: 0.01rem;
  box-sizing: border-box;
}

.app div {
  overflow-x: hidden;
  white-space: nowrap;
}

.app div p {
  width: fit-content;
  transition: transform 16.7ms;
  line-height: 100%;
  margin: 0;
  display: flex;
}

.app div p span {
  display: inline-block;
  padding-right: 0.1rem;
  line-height: 100%;

}
</style>
